// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__17T4o","header":"ReportDetails_header__3DE1K","title":"ReportDetails_title__2SeEE","left":"ReportDetails_left__3nCOF"};